import { GlobalOutlined } from "@ant-design/icons";
import { Switch } from "antd/";

import React from "react";

// import { useTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import withSharedStateConsumer from "../contexts/shared-state/withSharedStateConsumer";
class LanguageSwitcher extends React.Component {
  // const { i18n } = useTranslation();
  constructor(props) {
    super(props);
  }

  render() {
    let langAndDir = this.props.context;
    return (
      <Translation>
        {(t, { i18n }) => (
          <div className="select">
            <Switch
              // size="small"
              checkedChildren={
                this.props.context.curr_lang === "ar" ? "ع" : "en"
              }
              unCheckedChildren={
                this.props.context.curr_lang === "ar" ? "ع" : "en"
              }
              defaultChecked
              onChange={(e) => {
                if (i18n.language === "en") {
                  i18n.changeLanguage("ar");
                  langAndDir.updateLangAndDir("ar", "rtl");
                  document.querySelector("html").dir = "rtl";
                  sessionStorage.setItem("dir", "rtl");
                } else {
                  i18n.changeLanguage("en");
                  langAndDir.updateLangAndDir("en", "ltr");
                  document.querySelector("html").dir = "ltr";
                  // document.querySelector("html").lang = "en";
                  sessionStorage.setItem("dir", "ltr");
                }
              }}
              style={
                this.props.context.curr_dir === "ltr"
                  ? {
                      position: "relative",
                      left: "-31px",
                      top: "-30px",
                      background: "rgb(216, 56, 50)",
                    }
                  : {
                      position: "relative",
                      right: "-31px",
                      top: "-30px",
                      background: "rgb(216, 56, 50)",
                    }
              }
            />
          </div>
        )}
      </Translation>
    );
  }
}
export default withSharedStateConsumer(LanguageSwitcher);
